import { useVenueDataContext } from '@/VenueDataLoader'

export function useSalutationOption() {
  const { salutationOptions } = useVenueDataContext()
  return { salutationOptions }
}
